const CUTOFF_DATE_STRING = '2025-04-25';
const EXPERIMENTAL_PASSWORD = 'traceair2';
const EXPERIMENTAL_ACCESS_DURATION_DAYS = 7;

const EXPERIMENTAL_ACCESS_KEY = 'experimentalAccessGrantedUntil';
const EXPERIMENTAL_HOSTNAME = 'pilot-experimental.traceair.net';
const PRODUCTION_HOSTNAME = 'pilot.traceair.net';

const hasValidExperimentalAccess = () => {
  const expiryString = localStorage.getItem(EXPERIMENTAL_ACCESS_KEY);
  if (expiryString) {
    const expiryDate = new Date(expiryString);
    if (expiryDate > new Date()) {
      return true;
    }
    localStorage.removeItem(EXPERIMENTAL_ACCESS_KEY);
  }

  const enteredPassword = prompt(
    `This domain is used for testing new beta features and is password-protected.\n` +
      `If you cancel or enter an incorrect password, you will be redirected to the production version.`,
  );

  if (enteredPassword === EXPERIMENTAL_PASSWORD) {
    const newExpiryDate = new Date();
    newExpiryDate.setDate(newExpiryDate.getDate() + EXPERIMENTAL_ACCESS_DURATION_DAYS);
    try {
      localStorage.setItem(EXPERIMENTAL_ACCESS_KEY, newExpiryDate.toISOString());
    } catch (e) {
      console.warn('Could not save experimental access token to localStorage:', e);
    }
    return true;
  }

  return false;
};

export const redirectFromExperimentalToProdIfNecessary = () => {
  const isExperimentalDomain = window.location.hostname === EXPERIMENTAL_HOSTNAME;
  const isAfterCutoffDate = new Date() > new Date(CUTOFF_DATE_STRING);

  if (isExperimentalDomain && isAfterCutoffDate) {
    if (!hasValidExperimentalAccess()) {
      alert(
        'Access to the experimental domain was not granted. ' +
          'This domain is used for testing new beta features. Please remove it from your bookmarks. ' +
          'You will be redirected to the production version shortly.',
      );

      const currentUrl = new URL(window.location.href);
      currentUrl.hostname = PRODUCTION_HOSTNAME;
      window.location.href = currentUrl.toString();
    }
  }
};
